import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import styled from 'styled-components';
import { STORAGE_TYPE, setInStorage } from '../../service/storageService';
import { stashToken } from '../../actions/authentication';
/* global Office */

const Container = styled.div`
    position: relative;
    height: 50vh;
    p {
        transform: translate(-50%, -50%);
        font-family: Arial;
        text-align: center;
        position: absolute;
        font-size: 18px;
        margin: 0;
        left: 50%;
        top: 50%;
    }
`;

const SsoCallback = ({ location }) => {
    const [error, SetError] = useState('');

    /**
     * The messageParent event doesn't work for the Edge browser, so we'll have to set
     * the auth tokens in local_storage from here.   The parent sidebar will be polling
     * for the auth tokens (for the Edge browser only) to determine a successful login
     * @param {*} paramsObj
     */
    const loginSSO = paramsObj => {
        if (paramsObj.token_type && paramsObj.token_type === 'Bearer') {
            if (paramsObj.access_token && paramsObj.access_token !== '') {
                setInStorage(
                    'authToken',
                    `${paramsObj.token_type} ${paramsObj.access_token}`,
                    STORAGE_TYPE.LOCAL_STORAGE
                );
                document.cookie = `authToken=${paramsObj.token_type} ${paramsObj.access_token}`;

                setInStorage('authType', 'OAuth2', STORAGE_TYPE.LOCAL_STORAGE);
                document.cookie = 'authType=OAuth2';

                stashToken(`${paramsObj.token_type} ${paramsObj.access_token}`, 'OAuth2');
            }

            return;
        }

        if (paramsObj.nonce && paramsObj.nonce !== '') {
            // we have the SSO SAML Nonce
            setInStorage('saml_nonce', paramsObj.nonce, STORAGE_TYPE.LOCAL_STORAGE);
            document.cookie = `saml_nonce=${paramsObj.nonce}`;
        }
    };

    const forceClose = () => {
        try {
            window.close();
        } catch (err) {
            console.log('err =', err);
        }
    };

    useEffect(() => {
        const paramsObj = queryString.parse(location.search);
        if (paramsObj.error) {
            SetError(paramsObj.error);
        } else {
            loginSSO(paramsObj);
            const paramsStr = JSON.stringify(paramsObj);
            try {
                Office.context.ui.messageParent(paramsStr);
            } catch (err) {
                setTimeout(() => forceClose(), 5000);
            }
        }
    }, []);

    return (
        <Container>
            {error ? (
                <p>
                    We seem to have a problem signing you in using SSO, please try again or use the
                    credential option instead.
                </p>
            ) : (
                <p>Successfully logged-in. Please close this browser window</p>
            )}
        </Container>
    );
};

export default SsoCallback;
